import React from "react";

export const Alarm = () => (
  <svg
    width="55"
    height="55"
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="55" height="55" fill="white" />
    <path
      d="M27.5 48.125C23.7607 48.125 20.1053 47.0161 16.9962 44.9387C13.8871 42.8612 11.4639 39.9085 10.0329 36.4538C8.60191 32.9992 8.22751 29.1977 8.95701 25.5303C9.68651 21.8628 11.4872 18.4941 14.1312 15.85C16.7753 13.2059 20.1441 11.4052 23.8116 10.6757C27.479 9.94624 31.2804 10.3206 34.7351 11.7516C38.1898 13.1826 41.1425 15.6058 43.22 18.715C45.2974 21.8241 46.4062 25.4794 46.4062 29.2187C46.4062 34.233 44.4143 39.0418 40.8687 42.5875C37.3231 46.1331 32.5142 48.125 27.5 48.125ZM27.5 13.75C24.4406 13.75 21.4498 14.6572 18.906 16.3569C16.3622 18.0566 14.3795 20.4725 13.2087 23.2991C12.0379 26.1256 11.7316 29.2359 12.3285 32.2365C12.9253 35.2372 14.3986 37.9934 16.5619 40.1568C18.7253 42.3201 21.4815 43.7934 24.4822 44.3902C27.4828 44.9871 30.5931 44.6808 33.4196 43.51C36.2462 42.3392 38.6621 40.3565 40.3618 37.8127C42.0615 35.2689 42.9687 32.2781 42.9687 29.2187C42.9687 25.1161 41.339 21.1816 38.438 18.2807C35.5371 15.3797 31.6026 13.75 27.5 13.75Z"
      fill="#161616"
    />
    <path
      d="M13.0309 6.88038L6.87561 13.0486L9.30883 15.4767L15.4642 9.30852L13.0309 6.88038Z"
      fill="#161616"
    />
    <path
      d="M41.9635 6.8653L39.5303 9.29343L45.6856 15.4616L48.1188 13.0335L41.9635 6.8653Z"
      fill="#161616"
    />
    <path d="M36.0937 27.5H18.9062V30.9375H36.0937V27.5Z" fill="#161616" />
  </svg>
);
